import React from "react";
import { ITableModel } from "components/Table/interface";
import { IWonItemRow } from "./WonItemsDetailDropdown";
import { Cell } from "pages/Quotes/components/generics/DetailsTable/styles";

function CellNoWrap({ value }: { value: string | undefined }) {
  const text = value ?? "-";
  return (
    <span
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block",
        maxWidth: "100%",
      }}
      title={text}
    >
      {text}
    </span>
  );
}

export function wonItemsTableModel(): ITableModel[] {
  return [
    {
      label: "Código",
      key: "code",
      size: 205,
      maxSize: 205,
      noFilter: true,
      Component: (data: IWonItemRow) => (
        <span className="color-blue-gray">
          <CellNoWrap value={data.code} />
        </span>
      ),
    },
    {
      label: "Descrição",
      key: "description",
      size: 600,
      maxSize: 600,
      noFilter: true,
      Component: (data: IWonItemRow) => (
        <span
          className="color-blue-gray"
          title={data.description ?? "-"}
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical" as const,
            overflow: "hidden",
            wordBreak: "break-word",
          }}
        >
          {data.description ?? "-"}
        </span>
      ),
    },
    {
      label: "Marca",
      key: "brand",
      size: 325,
      maxSize: 325,
      noFilter: true,
      Component: (data: IWonItemRow) => (
        <span className="color-blue-gray">
          {data.brand}
        </span>
      ),
    },
  ];
}
